module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/point_navy-ee28a48e2fc56ca803e0d7af9aefe970.png";